import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, provider, db } from "../../firebaseConfig";
import AuthLayout from "./AuthLayout";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const checkUserRoleAndRedirect = async (uid) => {
        try {
            // Check if user is a brand
            const brandDoc = await getDoc(doc(db, "brands", uid));
            if (brandDoc.exists()) {
                navigate("/brand/dashboard");
                return;
            }

            // Check if user is a creator
            const creatorDoc = await getDoc(doc(db, "creators", uid));
            if (creatorDoc.exists()) {
                navigate("/creator/dashboard");
                return;
            }

            // If neither, go to onboarding (or role selection)
            navigate("/onboarding");
        } catch (err) {
            console.error("Error checking user role:", err);
            // Fallback to onboarding on error
            navigate("/onboarding");
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            await checkUserRoleAndRedirect(userCredential.user.uid);
        } catch (err) {
            console.error("Login Error:", err);
            setError("Invalid email or password.");
        }
    };

    const handleGoogleLogin = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            await checkUserRoleAndRedirect(result.user.uid);
        } catch (err) {
            console.error("Google Login Error:", err);
            setError("Failed to sign in with Google.");
        }
    };

    return (
        <AuthLayout title="Welcome back">
            <form className="space-y-4 mb-6" onSubmit={handleLogin}>
                <Input
                    placeholder="Email address"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Input
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                {error && <p className="text-red-500 text-sm text-center">{error}</p>}

                <div className="pt-2">
                    <Button fullWidth variant="primary" type="submit">Login</Button>
                </div>
            </form>

            <div className="flex flex-col items-center space-y-4">
                <p className="text-sm text-gray-500 font-medium">or login with</p>

                <div className="flex gap-4">
                    <button
                        type="button"
                        onClick={handleGoogleLogin}
                        className="p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"
                    >
                        <FcGoogle size={24} />
                    </button>
                    <button type="button" className="p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                        <FaApple size={24} />
                    </button>
                </div>

                <div className="mt-8 pt-4">
                    <p className="text-sm font-medium text-gray-800">
                        Don't have an account? <Link to="/signup" className="text-blue-600 hover:underline">Sign up</Link>
                    </p>
                </div>
            </div>
        </AuthLayout>
    );
};

export default LoginPage;
